export function DistributionManifestListTabs() {
  return [
    {
      text: "All",
      path: `/distribution-manifest?tab=all`,
      applicationFeatureCode: "DistributionManifest",
      id: "all",
    },
    {
      text: "Planned",
      path: `/distribution-manifest?tab=planned`,
      applicationFeatureCode: "DistributionManifest",
      id: "planned",
    },
    {
      text: "Booked",
      path: `/distribution-manifest?tab=booked`,
      applicationFeatureCode: "DistributionManifest",
      id: "booked",
    },
    {
      text: "Despatched",
      path: `/distribution-manifest?tab=despatched`,
      applicationFeatureCode: "DistributionManifest",
      id: "despatched",
    },
    {
      text: "Cancelled",
      path: `/distribution-manifest?tab=cancelled`,
      applicationFeatureCode: "DistributionManifest",
      id: "cancelled",
    },
  ];
}

export function GetIndexByTabName(tabName) {
  const tabs = DistributionManifestListTabs();
  const index = tabs.findIndex(
    (tab) => tab.text.toLowerCase() === tabName.toLowerCase()
  );
  return index !== -1 ? index : 0;
}

export function GetTabTextByTabName(tabName) {
  const tabs = DistributionManifestListTabs();
  const tab = tabs.find(
    (tab) => tab.text.toLowerCase() === tabName.toLowerCase()
  );
  return tab ? tab.text : "All";
}

export const DistributionManifestTabFilters = {
  all: [],
  planned: [["Status", "=", "P"]],
  booked: [["Status", "=", "B"]],
  despatched: [["Status", "=", "S"]],
  cancelled: [["Status", "=", "C"]],
};
